import { DefaultFocusStatusModel } from "../../../models/DefaultFocusStatusModel";
import { KeyboardNavigation } from "./KeyboardNavigation";

export class ButtonChoiceNavigation extends KeyboardNavigation {
    findNextFocusableElementWithinSameVariable(
        currentElement: DefaultFocusStatusModel,
        eventKey: string,
    ): DefaultFocusStatusModel | null {
        const index = this.defaultFocusStatus.statuses.indexOf(currentElement);

        for (let i = 0; i < this.defaultFocusStatus.statuses.length; i++) {
            const elementFocusStatus = this.defaultFocusStatus.statuses[i];
            let indexCondition = false;

            if (eventKey === "ArrowDown" || eventKey === "ArrowRight") {
                indexCondition = i > index;
            } else if (eventKey === "ArrowLeft" || eventKey === "ArrowUp") {
                indexCondition = i === index - 1;
            }

            if (
                elementFocusStatus.variableId === currentElement.variableId &&
                elementFocusStatus.elementId !== currentElement.elementId &&
                indexCondition
            ) {
                return elementFocusStatus;
            }
        }

        return null;
    }

    findNextFocusableElementWithinNextVariable(
        currentElement: DefaultFocusStatusModel,
    ): DefaultFocusStatusModel | null {
        const index = this.defaultFocusStatus.statuses.indexOf(currentElement);

        for (let i = index + 1, len = this.defaultFocusStatus.statuses.length; i < len; i++) {
            const elementFocusStatus = this.defaultFocusStatus.statuses[i];

            if (
                (elementFocusStatus.variableId !== 0 &&
                    elementFocusStatus.variableId !== currentElement.variableId && elementFocusStatus.elementRef?.current) ||
                currentElement.elementId.includes("CHECK")
            ) {
                return this.getFocusableElement(elementFocusStatus, true);
            }
        }

        return null;
    }

    findLastFocusableElementWithinPreviousVariable(
        currentElement: DefaultFocusStatusModel,
    ): DefaultFocusStatusModel | null {
        const index = this.defaultFocusStatus.statuses.indexOf(currentElement);

        for (let i = index - 1; i >= 0; i--) {
            const elementFocusStatus = this.defaultFocusStatus.statuses[i];

            if (
                elementFocusStatus.variableId !== 0 && elementFocusStatus.elementRef?.current &&
                (elementFocusStatus.variableId !== currentElement.variableId ||
                    elementFocusStatus.elementRef.current.tagName === "INPUT" ||
                    elementFocusStatus.elementRef.current.tagName === "TEXTAREA" ||
                    currentElement.elementId.includes("CHECK"))
            ) {
                return this.getFocusableElement(elementFocusStatus);;
            }
        }

        return null;
    }
}
